export default __webpack_public_path__ + "static/media/login-error-amber.5ce1c5e0.svg";